<div *ngIf="allCategories && !operationCreated" class="card p-2 m-2">
    <div class="sticky-top">
        <div class="Tabletitle">Bulk Update Metadata</div>
    </div>
    <div class="card-body">
        <form [formGroup]="bulkUpdateForm" #updateForm="ngForm">
            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Name</span>
                </div>
                <input class="form-control" name="name" type="text" formControlName="name" required>
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-105">Categories</span>
                </div>
                <mat-select [(ngModel)]="formCategory" formControlName="categoryId" name="category" (selectionChange)="getCategoryMetadata(formCategory)" (ngModelChange)="formCategory" class="form-control" required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let category of allCategories.results |stringFilter:searchCtrl:'name'" [value]="category.id">
                        {{category.name}}
                    </mat-option>
                </mat-select>
            </div>

            <div class="card p-2 m-3 mb-2">
                <div formArrayName="searchAttributeValues">
                    <div class="form-group row">
                        <span class="form-group ml-3 form-label-105">Search Attributes</span>
                        <div class="col mb-2">
                            <button mat-stroked-button class="float-right" title="Add Form" (click)="addSearchAttributeValue()">
                                <mat-icon>add</mat-icon>Add Attribute
                            </button>
                        </div>
                    </div>
                    <div *ngFor="let section of getSearchAttribute(bulkUpdateForm); let i = index" [formGroupName]="i">
                        <div class="row">
                            <div class="col-5">
                                <div class="input-group-sm mb-3 input-group col">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Attribute</span>
                                    </div>
                                    <mat-select [(ngModel)]=searchAttributes[i] formControlName="searchAttribute" (selectionChange)="getSearchAttributes()" class="form-control" required>
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <div *ngFor="let property of searchAttributesDropDown |stringFilter:searchCtrl:'name'">
                                            <mat-option *ngIf="property.disabled" [value]="property.value" disabled>
                                                {{property.value}}
                                            </mat-option>
                                            <mat-option *ngIf="!property.disabled" [value]="property.value">
                                                {{property.value}}
                                            </mat-option>
                                        </div>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-group-sm mb-3 input-group col">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Value</span>
                                    </div>
                                    <input class="form-control" type="text" formControlName="searchValue" required>
                                </div>
                            </div>
                            <div class="col-1">
                                <mat-icon *ngIf="searchFormArray.controls.length > 1" (click)="deleteSearchAttributeValue(i)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card p-2 m-3 mb-2">
                <div formArrayName="targetAttributeValues">
                    <div class="form-group row">
                        <span class="form-group ml-3 form-label-105">Target Attributes</span>
                        <div class="col mb-2">
                            <button mat-stroked-button class="float-right" title="Add Form" (click)="addTargetAttributeValue()">
                                <mat-icon>add</mat-icon>Add Attribute
                            </button>
                        </div>
                    </div>
                    <div *ngFor="let section of getTargetAttribute(bulkUpdateForm); let i = index" [formGroupName]="i">
                        <div class="row">
                            <div class="col-5">
                                <div class="input-group-sm mb-3 input-group col">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Attribute</span>
                                    </div>
                                    <mat-select [(ngModel)]="targetAttributes[i]" formControlName="targetAttribute" class="form-control" (selectionChange)="getTargetAttributes()" required>
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <div *ngFor="let attribute of targetAttributesDropDown |stringFilter:searchCtrl:'name'">
                                            <mat-option *ngIf="attribute.disabled" [value]="attribute.value" disabled>
                                                {{attribute.value}}
                                            </mat-option>
                                            <mat-option *ngIf="!attribute.disabled" [value]="attribute.value">
                                                {{attribute.value}}
                                            </mat-option>
                                        </div>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-group-sm mb-3 input-group col">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Value</span>
                                    </div>
                                    <input class="form-control" type="text" formControlName="targetValue" required>
                                </div>
                            </div>
                            <div class="col-1">
                                <mat-icon *ngIf="targetFormArray.controls.length > 1" (click)="deleteTargetAttributeValue(i)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button class="action-button" mat-raised-button [disabled]="!updateForm.valid" (click)="applyBulkUpdate()">Update</button>
        </form>
    </div>
</div>
<div *ngIf="operationCreated" class="card m-2">
    <div class="card-body">
        <div>
            {{message}}
        </div>
        <button mat-stroked-button style="float: right;" (click)="back()">Close</button>
    </div>
</div>